export default {"src":"/_next/static/media/headerIconGroup.20a09928.svg","height":221,"width":170,"blurWidth":0,"blurHeight":0};